var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListenVoicemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-289 381 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-267.2,396.5c-2.8,0-5,2.3-5,5c0,1.1,0.4,2.3,1.1,3.1h-4.1c1.8-2.1,1.4-5.3-0.7-7c-0.9-0.7-2-1.1-3.1-1.1 c-2.8-0.1-5.1,2-5.2,4.8s2,5.1,4.8,5.2h12.3c2.8,0.1,5.1-2,5.2-4.8c0.1-2.8-2-5.1-4.8-5.2H-267.2z M-279,404.7 c-1.8,0-3.2-1.5-3.2-3.2c0-1.6,1.2-3,2.8-3.1h0.3c1.8,0.1,3.1,1.7,2.9,3.4C-276.2,403.3-277.4,404.6-279,404.7z M-267.2,404.7 c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2c0,0,0,0,0,0l0,0C-264,403.3-265.4,404.7-267.2,404.7 L-267.2,404.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-278.8,391.1c3.2-3.2,8.4-3.2,11.7,0c0.3,0.2,0.6,0.2,0.8-0.1c0.2-0.2,0.2-0.5,0-0.7c-3.7-3.7-9.7-3.7-13.3,0 c-0.2,0.3-0.2,0.6,0.1,0.8c0,0,0,0,0,0C-279.3,391.3-279,391.3-278.8,391.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-277.1,392.7c2.3-2.3,6-2.3,8.3,0c0.2,0.2,0.6,0.2,0.8,0c0,0,0,0,0,0l0,0c0.2-0.2,0.2-0.6,0-0.8c0,0,0,0,0,0 c-2.8-2.8-7.2-2.8-10,0c0,0,0,0,0,0l0,0c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0c0,0,0,0,0,0H-277.1L-277.1,392.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-275.5,394.4c1.4-1.4,3.6-1.4,5,0l0,0c0.2,0.3,0.6,0.3,0.9,0.1c0.3-0.2,0.3-0.5,0.2-0.8l0,0l-0.1-0.1 c-1.9-1.8-4.8-1.8-6.7,0c-0.3,0.2-0.4,0.6-0.2,0.8c0,0,0,0,0,0c0.2,0.3,0.5,0.4,0.8,0.2c0,0,0,0,0,0l0,0l0,0 C-275.6,394.6-275.6,394.5-275.5,394.4L-275.5,394.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenVoicemail);
export default __webpack_public_path__ + "static/media/listen-voicemail.9676cbf5.svg";
export { ForwardRef as ReactComponent };